module.exports = __webpack_public_path__ + "static/shield-93d654885323088802177bd969c73e5b.png";